import { apiFetch } from '../lib/api';

export interface PreviewEntry {
  name: string;
  group: string;
  tag_rule: string;
  product_count: number;
  example_skus: string[];
  vendor_mix: { source_guide: string; count: number }[];
  staged_only: boolean;
  warning?: string;
}

export interface CollectionsPreview {
  generated_at: string;
  total_planned: number;
  total_groups: number;
  total_empty: number;
  groups: string[];
  entries: PreviewEntry[];
}

export function getCollectionsPreview(): Promise<CollectionsPreview> {
  return apiFetch('/admin/collections-preview');
}

export interface WheelTagsResponse {
  wheel_id: number;
  sku: string;
  tags: string[];
}

export function getTagsForWheel(wheelId: number): Promise<WheelTagsResponse> {
  return apiFetch(`/admin/collections-preview/tags-for/${wheelId}`);
}
